import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiProvider } from "@src/store/ApiProvider";
import { pricingActions } from "..";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";
import { handleError } from "@src/store/getThunkAndSlice";

export interface IReleaseListingsParams {
	ListingIds: Array<number>;
}

const buildFormBody = (params: IReleaseListingsParams): URLSearchParams => {
	const body = new URLSearchParams();
	params.ListingIds.forEach((id) => body.append("ListingIds[]", String(id)));
	return body;
};

export const releaseListings = createAsyncThunk<boolean, IReleaseListingsParams>(
	"pricing/releaseListings",
	async (params, { dispatch, rejectWithValue, getState }) => {
		try {
			const body = buildFormBody(params);
			await ApiProvider.default.axios.post(`/api/Pricing/ReleaseListings?_dc=${Date.now()}`, body, {
				headers: { "Content-Type": "application/x-www-form-urlencoded" },
			});

			const rootState = getState() as RootState;
			const releasedIds = new Set(params.ListingIds);

			const newData = rootState.pricing.eventInventoryAll.data.map((item) => {
				if (!releasedIds.has(item.Listing_ID)) return item;
				return { ...item, On_Hold: false, On_Hold_Comments: "", Consignor_Hold: false };
			});
			const eventId = getInventoryCacheEventId(rootState);
			dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

			if (rootState.pricing.globalInventory.data.length) {
				const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((item) => {
					if (!releasedIds.has(item.Listing_ID)) return item;
					return { ...item, On_Hold: false, On_Hold_Comments: "", Consignor_Hold: false };
				});
				dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
			}

			return true;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	},
);

export const releaseListingsSlice = createSlice({
	name: "pricing/releaseListings",
	initialState: { loading: false, error: null as string | null },
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(releaseListings.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(releaseListings.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(releaseListings.rejected, (state, action) => {
				state.loading = false;
				state.error = (action.payload as string) ?? null;
			});
	},
});
